module.exports = __webpack_public_path__ + "static/media/background.6f79971c.png";